import { Box, CircularProgress } from '@material-ui/core';
import { FC } from 'react';
import { CustomTypography } from 'shared/elements/CustomTypography';

export const Progress: FC<{ isDeleting: boolean }> = ({ isDeleting }) => (
  <Box style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
    <CircularProgress size={18} />
    <CustomTypography fontSize={12}>{isDeleting ? 'Deleting' : 'In Progress'}...</CustomTypography>
  </Box>
);
